import { useState } from 'react';
import AppIcon from '../../components/AppIcon';


import Select from '../../components/ui/Select';
import EmailPreviewPanel from './components/EmailPreviewPanel';
import TestingControlsPanel from './components/TestingControlsPanel';
import DevicePreviewSelector from './components/DevicePreviewSelector';
import TestHistoryPanel from './components/TestHistoryPanel';

const EmailPreviewTesting = () => {
  const [selectedTemplate, setSelectedTemplate] = useState('booking-confirmation');
  const [deviceMode, setDeviceMode] = useState('desktop');
  const [emailClient, setEmailClient] = useState('gmail');
  const [testEmail, setTestEmail] = useState('');
  const [testHistory, setTestHistory] = useState([
    {
      id: 1,
      template: 'تأكيد حجز جديد',
      recipient: 'test@example.com',
      sentAt: '2026-01-11 14:30',
      status: 'delivered',
      client: 'Gmail'
    },
    {
      id: 2,
      template: 'تنبيه مصور',
      recipient: 'photographer@example.com',
      sentAt: '2026-01-11 13:15',
      status: 'delivered',
      client: 'Outlook'
    }
  ]);

  const templates = [
    { value: 'booking-confirmation', label: 'تأكيد حجز جديد - عميل' },
    { value: 'photographer-alert', label: 'تنبيه حجز جديد - مصور' },
    { value: 'payment-reminder', label: 'تذكير دفع معلق' },
    { value: 'payment-confirmation', label: 'تأكيد استلام الدفع' },
    { value: 'booking-update', label: 'تحديث حالة الحجز' },
    { value: 'session-reminder', label: 'تذكير موعد الجلسة' }
  ];

  const emailClients = [
    { value: 'gmail', label: 'Gmail' },
    { value: 'outlook', label: 'Outlook' },
    { value: 'apple-mail', label: 'Apple Mail' },
    { value: 'mobile-gmail', label: 'Gmail Mobile' },
    { value: 'mobile-outlook', label: 'Outlook Mobile' }
  ];

  const deviceModes = [
    { value: 'desktop', label: 'سطح المكتب', icon: 'Monitor' },
    { value: 'tablet', label: 'تابلت', icon: 'Tablet' },
    { value: 'mobile', label: 'موبايل', icon: 'Smartphone' }
  ];

  const templateData = {
    'booking-confirmation': {
      subject: 'تأكيد حجزك مع أحمد المصور',
      body: `مرحباً محمد العتيبي،

شكراً لحجزك جلسة تصوير أفراح مع أحمد المصور.

تفاصيل الحجز:
- التاريخ: 2026-01-25
- الوقت: 18:00 مساءً
- الموقع: قاعة الفرح، الرياض
- السعر: 3,500 ريال

رقم الحجز: BK-2026-001234

مع تحيات فريق مشهد`,
      variables: {
        customer_name: 'محمد العتيبي',
        photographer_name: 'أحمد المصور',
        service_type: 'أفراح',
        booking_date: '2026-01-25',
        booking_time: '18:00 مساءً',
        location: 'قاعة الفرح، الرياض',
        price: '3,500',
        booking_id: 'BK-2026-001234'
      }
    },
    'photographer-alert': {
      subject: 'طلب حجز جديد من محمد العتيبي',
      body: `مرحباً أحمد المصور،

لديك طلب حجز جديد!

تفاصيل العميل:
- الاسم: محمد العتيبي
- الخدمة: تصوير أفراح
- التاريخ المطلوب: 2026-01-25
- الوقت: 18:00 مساءً

يرجى مراجعة الطلب والرد في أقرب وقت.

رقم الحجز: BK-2026-001234`,
      variables: {
        photographer_name: 'أحمد المصور',
        customer_name: 'محمد العتيبي',
        service_type: 'تصوير أفراح',
        booking_date: '2026-01-25',
        booking_time: '18:00 مساءً',
        booking_id: 'BK-2026-001234'
      }
    },
    'payment-reminder': {
      subject: 'تذكير: دفعة معلقة للحجز BK-2026-001234',
      body: `مرحباً محمد العتيبي،

نذكرك بوجود دفعة معلقة لحجزك رقم BK-2026-001234.

المبلغ المطلوب: 3,500 ريال
تاريخ الاستحقاق: 2026-01-20

يرجى إتمام الدفع لتأكيد حجزك.

شكراً لك`,
      variables: {
        customer_name: 'محمد العتيبي',
        booking_id: 'BK-2026-001234',
        amount: '3,500',
        due_date: '2026-01-20'
      }
    },
    'payment-confirmation': {
      subject: 'تم استلام دفعتك بنجاح',
      body: `مرحباً محمد العتيبي،

تم استلام دفعتك بنجاح!

تفاصيل الدفع:
- المبلغ: 3,500 ريال
- رقم العملية: TXN-2026-567890
- التاريخ: 2026-01-11

حجزك مؤكد الآن.

شكراً لك`,
      variables: {
        customer_name: 'محمد العتيبي',
        amount: '3,500',
        transaction_id: 'TXN-2026-567890',
        payment_date: '2026-01-11'
      }
    },
    'booking-update': {
      subject: 'تحديث حالة حجزك BK-2026-001234',
      body: `مرحباً محمد العتيبي،

تم تحديث حالة حجزك رقم BK-2026-001234.

الحالة الجديدة: مؤكد

للمزيد من التفاصيل، يرجى زيارة لوحة التحكم.

مع تحيات فريق مشهد`,
      variables: {
        customer_name: 'محمد العتيبي',
        booking_id: 'BK-2026-001234',
        new_status: 'مؤكد'
      }
    },
    'session-reminder': {
      subject: 'تذكير: جلسة التصوير غداً',
      body: `مرحباً محمد العتيبي،

نذكرك بموعد جلسة التصوير غداً:

- الوقت: 18:00 مساءً
- الموقع: قاعة الفرح، الرياض
- المصور: أحمد المصور

نتطلع لرؤيتك!`,
      variables: {
        customer_name: 'محمد العتيبي',
        booking_time: '18:00 مساءً',
        location: 'قاعة الفرح، الرياض',
        photographer_name: 'أحمد المصور'
      }
    }
  };

  const currentTemplate = templateData?.[selectedTemplate];

  const handleSendTest = () => {
    if (!testEmail) {
      alert('يرجى إدخال البريد الإلكتروني');
      return;
    }

    const newTest = {
      id: testHistory?.length + 1,
      template: templates?.find(t => t?.value === selectedTemplate)?.label,
      recipient: testEmail,
      sentAt: new Date()?.toLocaleString('ar-SA', { 
        year: 'numeric', 
        month: '2-digit', 
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      }),
      status: 'delivered',
      client: emailClients?.find(c => c?.value === emailClient)?.label
    };

    setTestHistory([newTest, ...testHistory]);
    alert(`✅ تم إرسال إيميل تجريبي بنجاح!\n\nالمستلم: ${testEmail}\nالقالب: ${newTest?.template}\nالحالة: تم التسليم (وضع تجريبي)\n\nملاحظة: لم يتم إرسال إيميل فعلي. هذا اختبار محاكاة فقط.`);
    setTestEmail('');
  };

  const compatibilityStatus = [
    { client: 'Gmail', status: 'excellent', arabicSupport: true },
    { client: 'Outlook', status: 'good', arabicSupport: true },
    { client: 'Apple Mail', status: 'excellent', arabicSupport: true },
    { client: 'Yahoo Mail', status: 'good', arabicSupport: true },
    { client: 'Mobile Gmail', status: 'excellent', arabicSupport: true },
    { client: 'Mobile Outlook', status: 'good', arabicSupport: true }
  ];

  return (
    <div className="min-h-screen bg-background py-8 px-4 sm:px-6 lg:px-8" dir="rtl">
      <div className="max-w-7xl mx-auto">
        {/* Demo Mode Banner */}
        <div className="mb-6 bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
              <AppIcon name="Info" size={20} className="text-blue-600" />
            </div>
            <div>
              <h3 className="text-sm font-semibold text-blue-900 mb-1">وضع المعاينة والاختبار</h3>
              <p className="text-sm text-blue-700 leading-relaxed">
                يمكنك معاينة جميع قوالب الإيميل واختبار التوافق مع مختلف العملاء. 
                عند إرسال إيميل تجريبي، سيتم محاكاة العملية بدون إرسال فعلي.
              </p>
            </div>
          </div>
        </div>

        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <AppIcon name="Mail" size={32} className="text-primary" />
            <h1 className="text-3xl font-bold text-foreground">معاينة واختبار الإيميلات</h1>
          </div>
          <p className="text-muted-foreground">اختبر قوالب الإيميل عبر مختلف العملاء والأجهزة مع دعم كامل للنصوص العربية</p>
        </div>

        {/* Template Selector */}
        <div className="bg-card rounded-lg p-6 border border-border mb-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Select
              label="اختر القالب"
              options={templates}
              value={selectedTemplate}
              onChange={setSelectedTemplate}
            />
            <Select
              label="عميل البريد"
              options={emailClients}
              value={emailClient}
              onChange={setEmailClient}
            />
          </div>
        </div>

        {/* Device Preview Selector */}
        <DevicePreviewSelector
          deviceMode={deviceMode}
          deviceModes={deviceModes}
          onDeviceChange={setDeviceMode}
        />

        {/* Main Split View */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
          {/* Email Preview Panel (2/3 width) */}
          <div className="lg:col-span-2">
            <EmailPreviewPanel
              template={currentTemplate}
              deviceMode={deviceMode}
              emailClient={emailClient}
            />
          </div>

          {/* Testing Controls Panel (1/3 width) */}
          <div className="lg:col-span-1">
            <TestingControlsPanel
              testEmail={testEmail}
              onTestEmailChange={setTestEmail}
              onSendTest={handleSendTest}
              compatibilityStatus={compatibilityStatus}
            />
          </div>
        </div>

        {/* Test History */}
        <TestHistoryPanel testHistory={testHistory} />
      </div>
    </div>
  );
};

export default EmailPreviewTesting;